import { VueConstructor } from 'vue'
import { formatDate } from '@/utils/formatters'

export function installVue2GlobalProperties(Vue: VueConstructor) {
    Vue.prototype.$formatDate = formatDate
}
